import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup, signInWithEmailAndPassword } from "firebase/auth";
import { initializeApp } from "firebase/app";
import configData from "../config.json";

const firebaseConfig = configData.firebaseConfig;
// 🔥 Initialize Firebase once
const app = initializeApp(firebaseConfig);

// 🔐 Export auth instance
export const auth = getAuth(app);

export const handleGoogleLogin = async () => {
  try {
    const provider = new GoogleAuthProvider();
    const userCredential = await signInWithPopup(auth, provider);
    const firebaseUser = userCredential.user;

    const idToken = await firebaseUser.getIdToken();
    return idToken

  } catch (err) {
    console.error("Google login failed:", err);
    return null
  }
};

export const handleAppleLogin = async () => {
  const provider = new OAuthProvider("apple.com");
  try {
    const userCredential = await signInWithPopup(auth, provider);
    const firebaseUser = userCredential.user;
    const idToken = await firebaseUser.getIdToken();

    return idToken
  } catch (err) {
    console.error("Apple login failed:", err);
    return null
  }
};

export const handleMicrosoftLogin = async () => {
  const provider = new OAuthProvider("microsoft.com");
  try {
    const userCredential = await signInWithPopup(auth, provider);
    const firebaseUser = userCredential.user;
    const idToken = await firebaseUser.getIdToken();
    return idToken
    // send to backend as usual
  } catch (err) {
    console.error("Microsoft login failed:", err);
    return null
  }
};

export const handleUsernamePasswordLogin = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const firebaseUser = userCredential.user;
    const idToken = await firebaseUser.getIdToken();
    return idToken
  } catch (err) {
    console.error("Microsoft login failed:", err);
    return null
  }
};